"use client";

import { COOKIES } from ".constants/cookies";
import { useSuspenseQuery } from "@apollo/client";
import { cn } from "@cloai/uikit";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { filter, includes, isEmpty, map } from "lodash";
import { useLocale } from "next-intl";
import { useCookies } from "react-cookie";

import { GET_BANNERS } from "@/.graphql";
import {
  useABtestContext,
  useHeadersContext,
  useUndressContext,
} from "@/providers";
import { getCountry } from "@/utils/headers";

import { useCompany } from "../hooks/useCompany";
import { Offer } from "./Offer";

export const OffersCarousel = () => {
  const headers = useHeadersContext();
  const { isActive } = useUndressContext();
  const { AAB_RedesignV1 } = useABtestContext();

  const locale = useLocale();
  const { isOkbra } = useCompany();

  const [cookies] = useCookies([COOKIES.COUNTRY]);
  const $country = cookies.country ?? getCountry(headers);

  const { data } = useSuspenseQuery(GET_BANNERS);

  const filteredBanners = filter(data.getBanners, (item) => {
    if (!isEmpty(item.allowedCountries)) {
      return includes(item.allowedCountries, $country);
    }

    return !includes(item.disabledCountries, $country);
  });

  const [emblaRef] = useEmblaCarousel({ loop: true, dragFree: false }, [
    Autoplay({
      delay: 7000,
      active: true,
    }),
  ]);

  if (isEmpty(data.getBanners)) {
    return null;
  }

  if (isOkbra) {
    return null;
  }

  // AB-test баннера на главной
  if (!isActive && !AAB_RedesignV1) {
    return null;
  }

  return (
    // вся эта ебанина - чтобы победить дебильные маржины на десктопе
    <div
      className={cn(
        "mx-auto max-w-full shrink-0 overflow-hidden select-none",
        !AAB_RedesignV1 && "md:max-w-150",
      )}
    >
      <div className={cn(!AAB_RedesignV1 && "-mr-container pl-container")}>
        {/*  viewport */}
        <div className="relative" ref={emblaRef}>
          {/* container */}
          <div
            className={cn(
              "flex touch-pan-y transform-3d",
              !AAB_RedesignV1 && "-ml-container",
            )}
          >
            {map(filteredBanners, (offer, index) => (
              // slide
              <div
                key={index}
                className={cn(
                  "min-w-0 shrink-0 grow-0 basis-full transform-3d",
                  !AAB_RedesignV1 && "pl-container",
                )}
              >
                <Offer
                  {...offer}
                  title={offer.title[locale] || offer.title.en}
                  description={
                    offer.description[locale] || offer.description.en
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
